import { uuidv4 } from '../helpers/utils';
import { CumulioDashboard } from '../models/dashboard.model';
import { ItemData } from '../models/common.model';
export const getData = <T extends CumulioDashboard>(dashboardComponent: T, iframe: HTMLIFrameElement, itemId: string): Promise<ItemData> => {
  if (iframe?.contentWindow) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      {
        action: 'getData',
        id: itemId,
        _version: dashboardComponent.VERSION,
        requestId,
      },
      '*'
    );

    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      // Check if promise has been resolved after 2 seconds
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = 'getData request timed out.';
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2000);
    });
  }

  return Promise.reject(new Error('Cannot retrieve contentWindow.'));

};
